{
  "Call": "Anrufen",
  "Email": "E-Mail",
  "Directions": "Wegbeschreibung",
  "Users can click on this button to call your mobile number.": "Benutzer können auf diese Schaltfläche klicken, um Ihre Mobilnummer anzurufen.",
  "Users can tap this button to send you an email.": "Benutzer können auf diese Schaltfläche tippen, um Ihnen eine E-Mail zu senden.",
  "Got It": "Verstanden",
  "Location": "Ort",
  "Directions will open in Google Maps. Do you want to continue?": "Die Wegbeschreibung wird in Google Maps geöffnet. Möchten Sie fortfahren?",
  "Show directions": "Wegbeschreibung anzeigen",
  "Use Google Maps": "Google Maps verwenden",
  "Waiting for you to enter data": "Warten auf Ihre Eingabe von Daten",
  "Where": "Wo",
  "When": "Wann",
  "How would you like to save contact data?": "Wie möchten Sie die Kontaktdaten speichern?",
  "Save Contact Data": "Kontaktdaten speichern",
  "By tapping here, users are navigated to the linked social media profile or website.": "Durch Tippen hier werden Benutzer zum verknüpften Social-Media-Profil oder zur Website weitergeleitet.",
  "Mobile": "Mobil",
  "Website": "Website",
  "Social Media": "Soziale Medien",
  "Telephone": "Telefon",
  "Fax": "Telefax",
  "Show on map": "Auf Karte anzeigen",
  "Yes": "Ja",
  "No": "Nein",
  "Share page": "Seite teilen",
  "Copied": "Kopiert",
  "Send by Email": "Per E-Mail senden",
  "Email was sent": "E-Mail wurde gesendet",
  "Save to My Phone": "In Meinem Telefon speichern",
  "Send contact details using email.": "Kontaktdaten per E-Mail senden.",
  "Please look in your inbox, the email will arrive shortly.": "Bitte schauen Sie in Ihren Posteingang, die E-Mail wird in Kürze eintreffen.",
  "Enter Email Address": "E-Mail-Adresse eingeben",
  "Send": "Senden",
  "Copy": "Kopieren",
  "Copy Code": "Code kopieren",
  "Share": "Teilen",
  "Share this page": "Diese Seite teilen",
  "Text copied to the clipboard.": "Text wurde in die Zwischenablage kopiert.",
  "Download vCard": "vCard herunterladen",
  "Your visitors can click this button to download or send your vCard.": "Ihre Besucher können auf diese Schaltfläche klicken, um Ihre vCard herunterzuladen oder zu senden.",
  "25% OFF": "25% Rabatt",
  "Get coupon": "Gutschein erhalten",
  "Valid until": "Gültig bis",
  "Coupon Code": "Gutscheincode",
  "Terms and Conditions": "Geschäftsbedingungen",
  "Redeem now": "Jetzt einlösen",
  "Save Coupon Code": "Gutscheincode speichern",
  "View Location": "Ort anzeigen",
  "Get Tickets": "Tickets erhalten",
  "Start": "Start",
  "End": "Ende",
  "All day": "Den ganzen Tag",
  "Facility Features": "Einrichtungsmerkmale",
  "About": "Über uns",
  "Name": "Name",
  "Phone": "Telefon",
  "Facebook": "Facebook",
  "Twitter": "Twitter",
  "Opening Hours": "Öffnungszeiten",
  "Open Now": "Jetzt geöffnet",
  "Closed Now": "Jetzt geschlossen",
  "Closed": "Geschlossen",
  "...": "...",
  "Open": "Geöffnet",
  "Continue?": "Fortsetzen?",
  "Organizer": "Veranstalter",
  "Add event to calendar": "Ereignis zum Kalender hinzufügen",
  "Share event": "Ereignis teilen",
  "Contact": "Kontakt",
  "Some QR Codes types will show a live preview here but not this one": "Einige QR-Code-Typen zeigen hier eine Live-Vorschau, aber nicht dieser.",
  "View and test your QR Code in the next step!": "Sehen Sie sich Ihren QR-Code im nächsten Schritt an und testen Sie ihn!",
  "Read more": "Weiterlesen",
  "Show less": "Weniger anzeigen",
  "Waiting for you to enter a video": "Warten auf Ihr Video",
  "Joy's Cafe": "Joy's Café",
  "Eat. Refresh. Go": "Essen. Auffrischen. Los geht's.",
  "We aim to provide fresh and healthy snacks for people on the go.": "Wir möchten frische und gesunde Snacks für Menschen unterwegs bieten.",
  "Lorem ipsum dolor sit amet, consectetur adipiscing elit.": "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
  "View menu": "Menü anzeigen",
  "Mission Street": "Mission Street",
  "CA": "Kalifornien",
  "San Francisco": "San Francisco",
  "United States": "Vereinigte Staaten",
  "Joy": "Joy",
  "URL": "URL",
  "Instagram": "Instagram",
  "Jane Doe Agency": "Jane Doe Agentur",
  "Jane": "Jane",
  "Doe": "Doe",
  "Designer": "Designer",
  "W 100th St ": "W 100th St",
  "New York  ": "New York",
  "NY": "NY",
  "Elle Boutique": "Elle Boutique",
  "Storewide Holiday Sale": "Weihnachtsverkauf im gesamten Geschäft",
  "Get all of your holiday shopping done early this year! Discounted items on all designer clothing, bags, and more.": "Erledigen Sie Ihr gesamtes Weihnachtsshopping frühzeitig in diesem Jahr! Reduzierte Artikel für Designerkleidung, Taschen und mehr.",
  "17 Nov 2022": "17. Nov 2022",
  "18 Oct 2022": "18. Okt 2022",
  "(UTC)": "(UTC)",
  "Fairfield Ave": "Fairfield Ave",
  "PA": "Pennsylvania",
  "Homestead": "Homestead",
  "lorem ipsum dolor sit amet consectetur adipiscing elit sed": "lorem ipsum dolor sit amet consectetur adipiscing elit sed",
  "(Music for Man ) Relaxing Whiskey Blues Music - Modern Electric Guitar Blues - JAZZ & BLUES": "(Musik für den Mann) Entspannende Whiskey-Blues-Musik - Moderne E-Gitarren-Blues - JAZZ & BLUES",
  "Best Background Music 🎧 Chill music🎧 Party Mix 2022": "Beste Hintergrundmusik 🎧 Chill-Musik🎧 Party-Mix 2022",
  "JAZZ & BLUES": "JAZZ & BLUES",
  "ChillOut Music": "ChillOut-Musik",
  "WhatsApp": "WhatsApp",
  "Snapchat": "Snapchat",
  "Shop online": "Online einkaufen",
  "WebVantage": "WebVantage",
  "Engaging Title": "Ansprechender Titel",
  "Here we share awesome videos.": "Hier teilen wir großartige Videos.",
  "Visit us online": "Besuchen Sie uns online",
  "www.your-website.com": "www.deine-website.de",
  "Become a fan": "Werden Sie Fan",
  "YouTube": "YouTube",
  "Watch our videos": "Sehen Sie unsere Videos",
  "Connect with us on Social Media": "Verbinden Sie sich mit uns in den sozialen Medien",
  "Follow us and get updates delivered to your favorite social networks": "Folgen Sie uns und erhalten Sie Updates auf Ihre bevorzugten sozialen Netzwerke",
  "Room": "Zimmer",
  "Restaurant": "Restaurant",
  "Selection": "Auswahl",
  "Service": "Service",
  "Subcategory 1.1": "Unterkategorie 1.1",
  "Subcategory 1.2": "Unterkategorie 1.2",
  "Subcategory 1.3": "Unterkategorie 1.3",
  "Subcategory 1.4": "Unterkategorie 1.4",
  "Subcategory 2.1": "Unterkategorie 2.1",
  "Subcategory 2.2": "Unterkategorie 2.2",
  "Subcategory 3.1": "Unterkategorie 3.1",
  "Experiență excelentă!": "Ausgezeichnete Erfahrung!",
  "Mâncare delicioasă!": "Leckeres Essen!",
  "Serviciu mediu.": "Durchschnittlicher Service.",
  "Prețuri ridicate pentru calitatea oferită.": "Hohe Preise für die gebotene Qualität.",
  "Prețuri mici.": "Niedrige Preise.",
  "Hotel": "Hotel",
  "Give us a feedback": "Geben Sie uns ein Feedback",
  "Please select to review a category.": "Bitte wählen Sie eine Kategorie zur Überprüfung aus.",
  "Go to our website": "Besuchen Sie unsere Website",
  "Name this optional button as you want and link to any website of your choice.": "Benennen Sie diese optionale Schaltfläche nach Belieben und verlinken Sie sie mit einer Website Ihrer Wahl.",
  "How was your rental experience?": "Wie war Ihre Mietwagenerfahrung?",
  "Lake Cruisers": "Seeschifffahrt",
  "Winter 2017 Lookbook": "Winter-Lookbook 2017",
  "Brrrr... the cold days are coming! Luckily, our new collection arrived just in time. Get your favourite styles before they're gone!": "Brrrr... die kalten Tage kommen! Zum Glück ist unsere neue Kollektion rechtzeitig eingetroffen. Holen Sie sich Ihre Lieblingsstile, bevor sie ausverkauft sind!",
  "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.": "Lorem Ipsum ist einfach ein Blindtext der Druck- und Setzindustrie. Lorem Ipsum ist seit dem 16. Jahrhundert der Standard-Blindtext der Industrie, als ein unbekannter Drucker eine Galley mit Typen nahm und sie durcheinanderwarf, um ein Musterbuch zu erstellen. Es hat nicht nur fünf Jahrhunderte überstanden, sondern auch den Sprung in die elektronische Setzindustrie gemacht und im Wesentlichen unverändert überlebt.",
  "12 Jun 2023": "12. Jun 2023",
  "Sterling & Co": "Sterling & Co",
  "4th Annual Company Meetup": "4. Jährliches Unternehmertreffen",
  "Meet fellow Sterlings and the 'people behind the jobs'": "Treffen Sie Mitsterlings und die 'Menschen hinter den Jobs'",
  "Come join Sterling & Co. at our annual company meetup! Get to know fellow Sterlings and enjoy team building activities.": "Kommen Sie zu unserem jährlichen Unternehmertreffen von Sterling & Co.! Lernen Sie Mitsterlings kennen und genießen Sie Teambuilding-Aktivitäten.",
  "Sabaoani": "Sabaoani",
  "Progresului": "Progresului",
  "Neamt": "Neamt",
  "Romania": "Rumänien",
  "USA": "USA",
  "John Doe": "John Doe",
  "Eat. Refresh. Go.": "Essen. Auffrischen. Los geht's.",
  "W 100th St": "W 100th St",
  "New York": "New York",
  "Message us": "Nachricht senden",
  "ID": "ID",
  "FACEBOOK": "FACEBOOK",
  "Shop now": "Jetzt einkaufen",
  "Whatsapp": "WhatsApp",
  "From my vCard": "Von meiner vCard",
  "Copy Link": "Link kopieren",
  "(Copied)": "(Kopiert)",
  "More": "Mehr",
  "Menu": "Menü",
  "Your guests can click this button to quick add your event to their calendars.": "Ihre Gäste können auf diese Schaltfläche klicken, um Ihr Ereignis schnell ihrem Kalender hinzuzufügen.",
  "Choose your calendar format below.": "Wählen Sie unten Ihr Kalenderformat aus.",
  "Google Calendar": "Google Kalender",
  "Apple Calendar": "Apple Kalender",
  "Outlook Online": "Outlook Online",
  "Yahoo! Calendar": "Yahoo! Kalender",
  "Watch on YouTube": "Auf YouTube ansehen",
  "Less": "Weniger",
  "View PDF": "PDF anzeigen",
  "Go to our Page": "Zu unserer Seite gehen",
  "Go to our Facebook Page": "Zu unserer Facebook-Seite gehen",
  "URL is not valid": "Die URL ist ungültig",
  "Close (Esc)": "Schließen (Esc)",
  "Toggle full-screen": "Vollbild umschalten",
  "Zoom in/out": "Vergrößern/Verkleinern",
  "Previous (arrow left)": "Vorherige (Pfeil links)",
  "Next (arrow right)": "Nächste (Pfeil rechts)",
  "vcard": {
    "color1": "#455a64",
    "color2": "#e91e63",
    "color1b": "#ff0000",
    "avatar": { "bgColor": "#ffffff" },
    "welcome_screen": { "bgColor": "#ffffff" },
    "company": "Jane Doe Agency",
    "firstname": "Jane",
    "lastname": "Doe",
    "numbers_mobile": "+1-555-555-1234",
    "numbers_phone": "+1-555-555-0000",
    "email": "jane{'@'}email.com",
    "job": "Designer",
    "street_number": "",
    "number": "",
    "street": "W 100th St",
    "city": "New York",
    "state": "NY",
    "country": "Vereinigte Staaten",
    "zip": "10025",
    "website": "www.janedoe.com",
    "bio": "Ich bin Jane Doe"
  },
  "app": {
    "app_store": "https://apps.apple.com/us/app/instagram/id389801252",
    "play_store": "https://play.google.com/store/apps/details?id=com.instagram.android",
    "amazon_store": "https://www.amazon.com/Instagram/dp/B00KZP2DTQ",
    "fallbackUrl": "",
    "button": {
      "label": "Erfahren Sie mehr",
      "url": "https://www.instagram.com"
    },
    "name": "Instagram",
    "company": "Instagram, Inc.",
    "title": "Wir bringen Sie näher an die Menschen und Dinge, die Sie lieben.",
    "description": "Verbinden Sie sich mit Freunden, teilen Sie, was Sie gerade tun, oder sehen Sie, was es Neues von anderen auf der ganzen Welt gibt. Entdecken Sie unsere Community, in der Sie sich frei fühlen können, Sie selbst zu sein, und teilen Sie alles, von Ihren täglichen Momenten bis zu den Höhepunkten des Lebens.",
    "website": "https://www.instagram.com"
  },
  "business": {
    "company": "Joy's Cafe",
    "headline": "Essen. Auffrischen. Los geht's.",
    "teaser": "Wir möchten frische und gesunde Snacks für Menschen bieten, die unterwegs sind.",
    "venue": "",
    "about": "Kommen Sie zu unserem jährlichen Unternehmertreffen von Sterling & Co.! Lernen Sie Mitsterlings kennen und genießen Sie Teambuilding-Aktivitäten.",
    "callToAction": {
      "label": "Menü anzeigen",
      "url": "http://www.joyscafe.com"
    },
    "street": "W 100th St",
    "street_number": "",
    "state": "NY",
    "zip": "10025",
    "city": "New York",
    "country": "Vereinigte Staaten",
    "name": "Joy",
    "phone": "(000) 000-0000",
    "email": "hello{'@'}joyscafe.com",
    "website": "http://www.joyscafe.com"
  },
  "url": {
    "url": ""
  },
  "text": {
    "text": "Lorem Ipsum ist einfach ein Blindtext der Druck- und Setzindustrie. Lorem Ipsum ist seit dem 16. Jahrhundert der Standard-Blindtext der Industrie, als ein unbekannter Drucker eine Galley mit Typen nahm und sie durcheinanderwarf, um ein Musterbuch zu erstellen. Es hat nicht nur fünf Jahrhunderte überstanden, sondern auch den Sprung in die elektronische Setzindustrie gemacht und im Wesentlichen unverändert überlebt."
  },
  "coupon": {
    "company": "Elle Boutique",
    "headline": "Weihnachtsaktion im gesamten Geschäft",
    "name": "OFF25",
    "description": "Erledigen Sie Ihren Weihnachtseinkauf frühzeitig in diesem Jahr! Reduzierte Artikel in allen Designerkleidung, Taschen und mehr.",
    "sale": "25% RABATT",

    "website": {
      "label": "Jetzt einlösen",
      "url": "http://www"
    },
    "street": "W 100th St",
    "street_number": "",
    "state": "NY",
    "zip": "10025",
    "city": "New York",
    "country": "Vereinigte Staaten",
    "terms": "Lorem ipsum dolor sit amet consectetur adipiscing elit sed"
  },
  "event": {
    "organizer": "Sterling & Co",
    "title": "4. Jährliches Unternehmertreffen",
    "teaser": "Treffen Sie Mitsterlings und die 'Menschen hinter den Jobs'",
    "about": "Kommen Sie zu unserem jährlichen Unternehmertreffen von Sterling & Co.! Lernen Sie Mitsterlings kennen und genießen Sie Teambuilding-Aktivitäten.",
    "venue": "",
    "street": "W 100th St",
    "street_number": "",
    "state": "NY",
    "zip": "10025",
    "city": "New York",
    "country": "Vereinigte Staaten",
    "contact": "John Doe",
    "phone": "(000) 000-0000",
    "email": "hello{'@'}sterling.com",
    "website": "http://www.sterling.com",
    "callToAction": {
      "label": "Tickets erhalten",
      "url": "http://www.sterling.com"
    }
  },
  "video": {
    "callToAction": {
      "label": "Hol dir deins",
      "url": "http://bit.ly/2IgdnXT"
    },
    "company": "Larq",
    "headline": "Die weltweit erste selbstreinigende Wasserflasche",
    "description": "Die LARQ-Flasche ist die weltweit erste selbstreinigende Wasserflasche und Wasserreinigungssystem. Sie verwendet UV-C-LED-Licht, um bis zu 99,9999 % der Bio-Kontaminanten aus Ihrem Wasser und Ihrer Flasche zu entfernen."
  },
  "image": {
    "callToAction": {
      "label": "Erfahren Sie mehr",
      "url": "https://ro.pinterest.com/mcsyniam/winter-lookbook/"
    },
    "title": "Winter-Lookbook 2023",
    "website": "",
    "description": "Brrrr... die kalten Tage kommen! Zum Glück ist unsere neue Kollektion rechtzeitig eingetroffen. Holen Sie sich Ihre Lieblingsstile, bevor sie ausverkauft sind!"
  },
  "social-media": {
    "headline": "Verbinden Sie sich mit uns auf Social Media",
    "description": "Folgen Sie uns und erhalten Sie Updates auf Ihre Lieblings-Sozialenetzwerke",
    "website": {
      "value": "www.your-website.com",
      "text": "Besuchen Sie uns online"
    },
    "facebook": { "value": "www.facebook.com", "text": "Werden Sie Fan" },
    "youtube": { "value": "www.youtube.com", "text": "Sehen Sie unsere Videos" }
  },
  "facebook": {
    "title": "Klicken Sie auf den Like-Button, um uns auf Facebook zu folgen.",
    "facebookUrl": "https://www.facebook.com/facebook",
    "name": "Facebook",
    "website": "https://www.facebook.com"
  },
  "pdf": {
    "company": "Amazon",
    "title": "Liste der von uns geliebten Spielzeuge",
    "description": "Amazon präsentiert die Liste der von uns geliebten Spielzeuge 2023, darunter 200 Spielzeuge von Marken wie LEGO, Mattel, Magna-Tiles und Disney",
    "website": "www.amazon.com"
  },
  "mp3": {
    "title": "Sanssouci",
    "info": "Die letzte Station",
    "website": "https://www.youtube.com/{'@'}laststationoficial",
    "callToAction": {
      "label": "Besuchen Sie uns online",
      "url": "https://www.youtube.com/{'@'}laststationoficial"
    }
  }
}
